var map = {
	"./decidim/consultations/decidim_consultations.svg": "./vendor/decidim-gems/decidim-consultations/app/packs/images/decidim/consultations/decidim_consultations.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./vendor/decidim-gems/decidim-consultations/app/packs/images sync recursive ^\\.\\/.*$";